import { useLanguageContext } from "../../context/LanguageContext";
import EmployeeLogsPage from "../../pages/employees/log/EmployeeLogsPage";
import { useEmployeeLogsRouteValidator } from "../validators/EmployeeLogsRouteValidator";
import { RouteConfig } from "./RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useEmployeeLogsRouteConfig() {
  const { translate } = useLanguageContext();
  return new RouteConfig()
    .setPath("/dashboard/employee_logs")
    .setLabel(translate("eva.main.entities.employee_logs"))
    .setValidator(useEmployeeLogsRouteValidator())
    .setPage(<EmployeeLogsPage />);
}

export default useEmployeeLogsRouteConfig;
